import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { NotificationSubscriptionRow } from '../../../components/notification-settings'
import { theme } from '../../../styled'

function AngularNotificationSubscriptionRow({
  entry,
  i18nTitle,
  i18nSubtitle,
  fieldRequired,
  i18nTooltipTitle,
  i18nTooltipSubtitle,
  onToggle
}) {
  const intl = useIntl()

  return (
    <NotificationSubscriptionRow
      entry={entry}
      title={intl.formatMessage({ id: i18nTitle })}
      subtitle={intl.formatMessage({ id: i18nSubtitle })}
      fieldRequired={fieldRequired}
      tooltipContent={
        <div>
          <div
            className={css`
              font-weight: ${theme.fontWeights.secondary.boldest};
              line-height: 2;
              padding-bottom: 4px;
            `}
          >
            {intl.formatMessage({ id: i18nTooltipTitle })}
          </div>
          <div>{intl.formatMessage({ id: i18nTooltipSubtitle })}</div>
        </div>
      }
      onToggle={onToggle}
    />
  )
}

export const notificationSubscriptionRow = createNgReactBridgeDirective(
  'reactNotificationSubscriptionRow',
  [],
  AngularNotificationSubscriptionRow,
  [
    'entry',
    'i18nTitle',
    'i18nSubtitle',
    'fieldRequired',
    'i18nTooltipTitle',
    'i18nTooltipSubtitle',
    'onToggle'
  ]
)
